//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    requestBody: {
        competition: number;
        competitionIdV2?: null | undefined | string;
        participants: Array<{
            name?: null | undefined | string;
            participant: string;
            role?: null | undefined | string;
        }>;
        sport: string;
        template: string;
        timeSettings: {
            startTime: string;
            timeZone: string;
        };
    };
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/create-event -> post -> ${code}`);
    };
};

export const Response200IO = t.interface({
    active: t.boolean,
    antePost: t.boolean,
    autoTakeDown: t.union([t.null, t.undefined, t.boolean]),
    competition: t.number,
    display: t.boolean,
    eventType: t.union([t.null, t.undefined, t.string]),
    feedData: t.union([t.null, t.undefined, t.record(t.string, t.string)]),
    feedSettings: t.union([
        t.null,
        t.undefined,
        t.interface({
            eachWay: t.union([t.null, t.undefined, t.boolean]),
            prices: t.union([t.null, t.undefined, t.boolean]),
            results: t.union([t.null, t.undefined, t.boolean]),
            updates: t.union([t.null, t.undefined, t.boolean]),
        }),
    ]),
    grades: t.union([
        t.null,
        t.undefined,
        t.interface({
            inPlay: t.union([
                t.null,
                t.undefined,
                t.interface({
                    id: t.number,
                    name: t.string,
                }),
            ]),
            prematch: t.union([
                t.null,
                t.undefined,
                t.interface({
                    id: t.number,
                    name: t.string,
                }),
            ]),
            show: t.union([
                t.null,
                t.undefined,
                t.interface({
                    id: t.number,
                    name: t.string,
                }),
            ]),
        }),
    ]),
    id: t.number,
    idv2: t.string,
    inPlaySettings: t.union([
        t.null,
        t.undefined,
        t.interface({
            betDelay: t.number,
            tradedInPlay: t.boolean,
        }),
    ]),
    incidents: t.union([
        t.null,
        t.undefined,
        t.array(
            t.interface({
                addedManually: t.union([t.null, t.undefined, t.boolean]),
                bettable: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        type: t.union([t.null, t.undefined, t.string]),
                    }),
                ]),
                deleted: t.union([t.null, t.undefined, t.boolean]),
                editedManually: t.union([t.null, t.undefined, t.boolean]),
                feedUpdatable: t.union([t.null, t.undefined, t.boolean]),
                id: t.union([t.null, t.undefined, t.string]),
                period: t.union([t.null, t.undefined, t.string]),
                player: t.union([t.null, t.undefined, t.string]),
                team: t.union([t.null, t.undefined, t.string]),
                time: t.union([
                    t.null,
                    t.undefined,
                    t.interface({
                        minutes: t.union([t.null, t.undefined, t.number]),
                        seconds: t.union([t.null, t.undefined, t.number]),
                    }),
                ]),
            })
        ),
    ]),
    name: t.string,
    participants: t.record(
        t.string,
        t.interface({
            id: t.number,
            idv2: t.union([t.null, t.undefined, t.string]),
            metadata: t.union([t.null, t.undefined, t.record(t.string, t.string)]),
            name: t.union([t.null, t.undefined, t.string]),
            racing_form_details: t.union([
                t.null,
                t.undefined,
                t.array(
                    t.interface({
                        course_name: t.union([t.null, t.undefined, t.string]),
                        course_type: t.union([t.null, t.undefined, t.string]),
                        date: t.union([t.null, t.undefined, t.string]),
                        distance: t.union([t.null, t.undefined, t.string]),
                        finish_position: t.union([t.null, t.undefined, t.number]),
                        handicap: t.union([t.null, t.undefined, t.boolean]),
                        runners_count: t.union([t.null, t.undefined, t.number]),
                        starting_price: t.union([t.null, t.undefined, t.string]),
                    })
                ),
            ]),
            role: t.union([t.null, t.undefined, t.string]),
        })
    ),
    platformObject: t.union([
        t.null,
        t.undefined,
        t.interface({
            feedProviderName: t.union([t.null, t.undefined, t.string]),
            id: t.union([t.null, t.undefined, t.string]),
            name: t.union([t.null, t.undefined, t.string]),
        }),
    ]),
    rawGameState: t.union([t.null, t.undefined, t.string]),
    revision: t.number,
    sport: t.string,
    state: t.string,
    statistics: t.record(t.string, t.record(t.string, t.string)),
    stream: t.union([
        t.null,
        t.undefined,
        t.array(
            t.interface({
                eventId: t.number,
                eventName: t.string,
                geoRuleCountries: t.string,
                geoRuleType: t.union([t.literal('DENY'), t.literal('ALLOW')]),
                id: t.number,
                live: t.boolean,
                provider: t.string,
                universe: t.string,
            })
        ),
    ]),
    tags: t.record(t.string, t.string),
    template: t.string,
    timeSettings: t.interface({
        offAtStartTime: t.union([t.null, t.undefined, t.boolean]),
        startTime: t.string,
        started: t.boolean,
        timeZone: t.string,
        timeline: t.union([t.null, t.undefined, t.string]),
        tradedInPlay: t.boolean,
    }),
    updated: t.interface({
        updatedAt: t.string,
    }),
    updatedInMs: t.number,
    uuid: t.union([t.null, t.undefined, t.string]),
});
export type Response200Type = {
    active: boolean;
    antePost: boolean;
    autoTakeDown?: null | undefined | boolean;
    competition: number;
    display: boolean;
    eventType?: null | undefined | string;
    feedData?: null | undefined | Record<string, string>;
    feedSettings?:
        | null
        | undefined
        | {
              eachWay?: null | undefined | boolean;
              prices?: null | undefined | boolean;
              results?: null | undefined | boolean;
              updates?: null | undefined | boolean;
          };
    grades?:
        | null
        | undefined
        | {
              inPlay?:
                  | null
                  | undefined
                  | {
                        id: number;
                        name: string;
                    };
              prematch?:
                  | null
                  | undefined
                  | {
                        id: number;
                        name: string;
                    };
              show?:
                  | null
                  | undefined
                  | {
                        id: number;
                        name: string;
                    };
          };
    id: number;
    idv2: string;
    inPlaySettings?:
        | null
        | undefined
        | {
              betDelay: number;
              tradedInPlay: boolean;
          };
    incidents?:
        | null
        | undefined
        | Array<{
              addedManually?: null | undefined | boolean;
              bettable?:
                  | null
                  | undefined
                  | {
                        type?: null | undefined | string;
                    };
              deleted?: null | undefined | boolean;
              editedManually?: null | undefined | boolean;
              feedUpdatable?: null | undefined | boolean;
              id?: null | undefined | string;
              period?: null | undefined | string;
              player?: null | undefined | string;
              team?: null | undefined | string;
              time?:
                  | null
                  | undefined
                  | {
                        minutes?: null | undefined | number;
                        seconds?: null | undefined | number;
                    };
          }>;
    name: string;
    participants: Record<
        string,
        {
            id: number;
            idv2?: null | undefined | string;
            metadata?: null | undefined | Record<string, string>;
            name?: null | undefined | string;
            racing_form_details?:
                | null
                | undefined
                | Array<{
                      course_name?: null | undefined | string;
                      course_type?: null | undefined | string;
                      date?: null | undefined | string;
                      distance?: null | undefined | string;
                      finish_position?: null | undefined | number;
                      handicap?: null | undefined | boolean;
                      runners_count?: null | undefined | number;
                      starting_price?: null | undefined | string;
                  }>;
            role?: null | undefined | string;
        }
    >;
    platformObject?:
        | null
        | undefined
        | {
              feedProviderName?: null | undefined | string;
              id?: null | undefined | string;
              name?: null | undefined | string;
          };
    rawGameState?: null | undefined | string;
    revision: number;
    sport: string;
    state: string;
    statistics: Record<string, Record<string, string>>;
    stream?:
        | null
        | undefined
        | Array<{
              eventId: number;
              eventName: string;
              geoRuleCountries: string;
              geoRuleType: 'DENY' | 'ALLOW';
              id: number;
              live: boolean;
              provider: string;
              universe: string;
          }>;
    tags: Record<string, string>;
    template: string;
    timeSettings: {
        offAtStartTime?: null | undefined | boolean;
        startTime: string;
        started: boolean;
        timeZone: string;
        timeline?: null | undefined | string;
        tradedInPlay: boolean;
    };
    updated: {
        updatedAt: string;
    };
    updatedInMs: number;
    uuid?: null | undefined | string;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiProxyCreateEventRequest"
 */
export const openapi_proxy_create_event = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api-proxy/staff/create-event${query}`;

    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiProxyCreateEventParamsType = ParamsType;

export type OpenapiProxyCreateEventResponseType =
    | {
          status: 200;
          body: Response200Type;
      }
    | {
          status: 400;
          body: Response400Type;
      }
    | {
          status: 401;
          body: Response401Type;
      }
    | {
          status: 500;
          body: Response500Type;
      };

export type OpenapiProxyCreateEventResponse200Type = Response200Type;

export const openapiProxyCreateEventRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiProxyCreateEventResponseType> => {
    const response = await openapi_proxy_create_event(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyCreateEventRequest - unhandled response ${response.status}`);
};
